<template>
  <div class="questionnaire-view questionnaire-view-bg">
    <header class="questionnaire-view-header">
      <div class="flex items-center justify-between m-auto h-full float-left">
        <router-link v-if="!isExternalUser" to="/">
          <img src="@/assets/omind_logo.png" alt="" class="w-28 align-middle" id="img_logo">
        </router-link>
        <img v-else src="@/assets/omind_logo.png" alt="" class="w-28 align-middle"
            id="img_logo">
      </div>
    </header>
    <main class="questionnaire-view-main">
      <router-view />
    </main>
    <footer class="questionnaire-view-footer">
      <footer-component />
    </footer>
  </div>
</template>

<script>
import FooterComponent from '@/components/Home/Layout/FooterComponent.vue';

export default {
  name: 'QuestionnaireView',
  components: { FooterComponent },
  computed: {
    isExternalUser() {
      return !!this.$route.query.externalToken;
    },
  },
};
</script>

<style scoped>
.questionnaire-view {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.questionnaire-view-bg {
  background: #f8f8f8;
}

.questionnaire-view-header {
  flex-shrink: 0;
  width: 100%;
  top: 0;
  z-index: 10;
  padding: 0.25rem;
  background: var(--color-black);
}

.questionnaire-view-main {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.questionnaire-view-footer {
  flex-shrink: 0;
}
</style>
